function getKeyFromMonthly(key: string, plan: Plan, defaultValue = 0): number {
  return plan && plan.durations ? plan.durations[0].monthly[key] : defaultValue
}

export default getKeyFromMonthly
